import isNewMailToastEnabled from '../selectors/isNewMailToastEnabled';
import isNewMailSoundEnabled from '../selectors/isNewMailSoundEnabled';
import isReminderToastEnabled from '../selectors/isReminderToastEnabled';
import isReminderSoundEnabled from '../selectors/isReminderSoundEnabled';
import { getUserConfiguration } from 'owa-session-store';
import NewNotification from 'owa-service/lib/contract/NewNotification';

export default function isAppNotificationsOptionDirty() {
    const userOptions = getUserConfiguration().UserOptions;

    const newMailSoundEnabledInUserOptions = !!(userOptions.NewItemNotify & NewNotification.Sound);
    const newMailToastEnabledInUserOptions = !!(
        userOptions.NewItemNotify & NewNotification.EMailToast
    );

    return (
        newMailSoundEnabledInUserOptions !== isNewMailSoundEnabled() ||
        newMailToastEnabledInUserOptions !== isNewMailToastEnabled() ||
        userOptions.EnableReminderSound !== isReminderSoundEnabled() ||
        userOptions.EnableReminders !== isReminderToastEnabled()
    );
}
